import { useNavigate } from 'react-router-dom'
import { Table } from 'reactstrap'
import { enterKeyHandler } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import CustomSelectListInput from '../CustomSelectListInput'
import { initialFormValues, submitFormValues } from '../CustomUtils'
import DateRangeInput from '../DateRangeInput'
import FormHeading from '../FormHeading'
import FormSubmitButton from '../FormSubmitButton'
import TextInput from '../TextInput'

export default function OSRReportForm() {
  console.log('OSRReportForm rendered')

  let init = {
    researchDueDateFrom: '',
    researchDueDateTo: '',
    hardCopyDateFrom: '',
    hardCopyDateTo: '',
    microfilmDateFrom: '',
    microfilmDateTo: '',
    case: '',
    researchType: [],
  }

  const navigate = useNavigate()
  init = initialFormValues('OSRReportForm', navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))

  async function submitSearch() {
    console.log('OSRReportForm.submitSearch', inputs)
    inputs.orderBy = '1'
    inputs.orderDir = 'ASC'
    submitFormValues('OSRReportForm', navigate, inputs, 'osr.osr_chart')
  }

  return (
    <div className="custom-scroll">
      <form onSubmit={handleSubmit}>
        <div>
          <Table className="custom-table custom-form-table">
            <FormHeading headingText='Outstanding Research Chart' />
            <tbody>
              <DateRangeInput label='Research Due' name='researchDueDate' handleInputChange={handleInputChange} defaultValueFrom={inputs.researchDueDateFrom} defaultValueTo={inputs.researchDueDateTo} />
              <DateRangeInput label='Hard Copy Due' name='hardCopyDate' handleInputChange={handleInputChange} defaultValueFrom={inputs.hardCopyDateFrom} defaultValueTo={inputs.hardCopyDateTo} />
              <DateRangeInput label='Microfilm Due' name='microfilmDate' handleInputChange={handleInputChange} defaultValueFrom={inputs.microfilmDateFrom} defaultValueTo={inputs.microfilmDateTo} />
              <TextInput label='Case' name='case' handleInputChange={handleInputChange} defaultValue={inputs.case} />
              <CustomSelectListInput label="Production Type" handleChange={handleInputChange} multiple={true} name='researchType' modelName="Custom" entityName="research_type" defaultValue={inputs.researchType} />
            </tbody>
          </Table>
        </div>
        <FormSubmitButton />
      </form>
    </div >
  )
}